<div class="modal-header">
  <h5 class="modal-title">{{title }}</h5>
  <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
    (click)="modal.close('ferme')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form autocomplete="off" [formGroup]="form" (ngSubmit)="onConfirme()">
  <div class="modal-body">
    <div class="col-md-12">
      <aw-wizard #wizard class="arc-wizard">
        <!-- STEP 1 DU FORMULAIRE -->
        <aw-wizard-step stepTitle="Programme">
          <!-- Informations sur la promotion -->
          <div class="row">
            <span class="badge badge-primary my-2 f-14 width">
              Informations sur le programme
            </span>
          </div>
          <div class="form-group">
            <div class="row mb-2">
              <div class="col-md-3">
                <app-entity-finder [class]="'Owner'" [groups]="['owner']" [required]="true" [label]="'Bailleur'"
                  (uuid)="setOwnerUuid($event)" [selected]="ownerSelected" [placeholder]="'Sélectionnez un bailleur'">
                </app-entity-finder>
              </div>
              <div class="col-md-3">
                <label for="type">
                  Programme parent
                  <i class="fas fa-info-circle" placement="right" popoverTitle="Cette qu'il faut savoir"
                    [ngbPopover]="'Ce Programme sera une sous Programme du Programme parent'"></i>
                </label>
                <select formControlName="parent" class="form-control" id="promotion">
                  <option [value]="null">Sélectionnez</option>
                  <option *ngFor="let item of promotions" [value]="item?.uuid">{{item?.libelle}}</option>
                </select>
              </div>
              <div class="col-md-3">
                <label for="type">
                  Type <span class="asterix">*</span>
                  <i class="fas fa-info-circle" placement="right" popoverTitle="Ce qu'il faut savoir"
                    [ngbPopover]="'Le Programme de type A correspond à des Programmes constitué de maisons bases'"></i>
                </label>
                <select formControlName="type" class="form-control" id="type" [ngClass]="{
                    'is-invalid': submit && f.type.errors,
                    'is-valid': submit && f.type.valid
                  }">
                  <option *ngFor="let item of typeRow" [value]="item.value">{{item.label}}</option>
                </select>
                <div class="invalid-feedback" *ngIf="submit && f.type.errors">
                  <div *ngIf="f.type.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="libelle">Libellé <span class="asterix">*</span></label>
                <input type="text" class="form-control" formControlName="libelle" id="libelle" [ngClass]="{
                    'is-invalid': submit && f.libelle.errors,
                    'is-valid': submit && f.libelle.valid
                  }" placeholder="Libellé">
                <div class="invalid-feedback" *ngIf="submit && f.libelle.errors">
                  <div *ngIf="f.libelle.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="superficie">Superficie (m²) <span class="asterix">*</span></label>
                <input type="number" min="0" class="form-control" formControlName="superficie" id="superficie"
                  [ngClass]="{
                    'is-invalid': submit && f.superficie.errors,
                    'is-valid': submit && f.superficie.valid
                  }" placeholder="Superficie (m²)">
                <div class="invalid-feedback" *ngIf="submit && f.superficie.errors">
                  <div *ngIf="f.superficie.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="surfaceBati">Surface bâtie <span class="asterix">*</span></label>
                <input type="number" class="form-control" formControlName="surfaceBati" id="surfaceBati" [ngClass]="{
                    'is-invalid': submit && f.surfaceBati.errors,
                    'is-valid': submit && f.surfaceBati.valid
                  }" placeholder="Surface bâtie ">
                <div class="invalid-feedback" *ngIf="submit && f.surfaceBati.errors">
                  <div *ngIf="f.surfaceBati.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="montantCr">Coût de revient </label>
                <input type="number" class="form-control" formControlName="montantCr" id="montantCr" [ngClass]="{
                    'is-invalid': submit && f.montantCr.errors,
                    'is-valid': submit && f.montantCr.valid
                  }" placeholder="Coût de revient">
                <div class="invalid-feedback" *ngIf="submit && f.montantCr.errors">
                  <div *ngIf="f.montantCr.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="montantCc">Coût de construction </label>
                <input type="number" class="form-control" formControlName="montantCc" id="montantCc" [ngClass]="{
                    'is-invalid': submit && f.montantCc.errors,
                    'is-valid': submit && f.montantCc.valid
                  }" placeholder="Coût de construction">
                <div class="invalid-feedback" *ngIf="submit && f.montantCc.errors">
                  <div *ngIf="f.montantCc.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="montantAdmin">Coût administratif </label>
                <input type="number" class="form-control" formControlName="montantAdmin" id="montantAdmin" [ngClass]="{
                    'is-invalid': submit && f.montantAdmin.errors,
                    'is-valid': submit && f.montantAdmin.valid
                  }" placeholder="Coût administratif">
                <div class="invalid-feedback" *ngIf="submit && f.montantAdmin.errors">
                  <div *ngIf="f.montantAdmin.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="montantVrd">Coût de construction VRD </label>
                <input type="number" class="form-control" formControlName="montantVrd" id="montantVrd" [ngClass]="{
                    'is-invalid': submit && f.montantVrd.errors,
                    'is-valid': submit && f.montantVrd.valid
                  }" placeholder="Coût de construction VRD">
                <div class="invalid-feedback" *ngIf="submit && f.montantVrd.errors">
                  <div *ngIf="f.montantVrd.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="etat">Disponibilité <span class="asterix">*</span></label>
                <select formControlName="etat" class="form-control" id="etat" [ngClass]="{
                    'is-invalid': submit && f.etat.errors,
                    'is-valid': submit && f.etat.valid
                  }">
                  <option *ngFor="let item of etatRow" [value]="item.value">{{item.label}}</option>
                </select>
                <div class="invalid-feedback" *ngIf="submit && f.etat.errors">
                  <div *ngIf="f.etat.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="date">Date <span class="asterix">*</span></label>
                <input type="date" class="form-control" formControlName="date" id="date" [ngClass]="{
                    'is-invalid': submit && f.date.errors,
                    'is-valid': submit && f.date.valid
                  }">
                <div class="invalid-feedback" *ngIf="submit && f.date.errors">
                  <div *ngIf="f.date.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="isOffre">
                  Souhaitez-vous publier les offres de ce programme sur le site web public ? <span
                    class="asterix">*</span>
                </label>
                <select class="form-control" id="isOffre" formControlName="isOffre">
                  <option [value]="'NON'">Non</option>
                  <option [value]="'OUI'">Oui</option>
                </select>
              </div>
              <div class="col-md-3" *ngIf="f.isOffre.value === 'OUI'">
                <label for="dateOffre">Date de publication<span class="asterix">*</span></label>
                <input type="date" class="form-control" formControlName="dateOffre" id="dateOffre" [ngClass]="{
                    'is-invalid': submit && f.dateOffre.errors,
                    'is-valid': submit && f.dateOffre.valid
                  }">
                <div class="invalid-feedback" *ngIf="submit && f.dateOffre.errors">
                  <div *ngIf="f.dateOffre.errors.required">{{required.novide}}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- LOCATION -->
          <div class="row">
            <span class="badge badge-primary my-2 f-14 width"> Localisation </span>
          </div>
          <div class="form-group">
            <div class="row mb-2">
              <div class="col-md-3">
                <label for="ville">Ville <span class="asterix">*</span></label>
                <input type="text" class="form-control" formControlName="ville" id="ville" [ngClass]="{
                    'is-invalid': submit && f.ville.errors,
                    'is-valid': submit && f.ville.valid
                  }" placeholder="Ville">
                <div class="invalid-feedback" *ngIf="submit && f.ville.errors">
                  <div *ngIf="f.ville.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="commune">Commune <span class="asterix">*</span></label>
                <input type="text" class="form-control" formControlName="commune" id="commune" [ngClass]="{
                    'is-invalid': submit && f.commune.errors,
                    'is-valid': submit && f.commune.valid
                  }" placeholder="Commune">
                <div class="invalid-feedback" *ngIf="submit && f.commune.errors">
                  <div *ngIf="f.commune.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="quartier">Quartier <span class="asterix">*</span></label>
                <input type="text" class="form-control" formControlName="quartier" id="quartier" [ngClass]="{
                    'is-invalid': submit && f.quartier.errors,
                    'is-valid': submit && f.quartier.valid
                  }" placeholder="Quartier">
                <div class="invalid-feedback" *ngIf="submit && f.quartier.errors">
                  <div *ngIf="f.quartier.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="lng">Longitude</label>
                <input type="text" class="form-control" formControlName="lng" id="lng" placeholder="Longitude">
              </div>
              <div class="col-md-3">
                <label for="lat">Latitude</label>
                <input type="text" class="form-control" formControlName="lat" id="lat" placeholder="Latitude">
              </div>
            </div>
          </div>
          <agm-map [draggableCursor]="'default'" [mapTypeId]="'hybrid'" [latitude]="lat" [longitude]="lng" [zoom]="zoom"
            (mapClick)="updateGeo($event)" (zoomChange)="updateZoom($event)">
            <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
          </agm-map>

          <div class="row mb-2 mt-2">
            <div class="flex-grow-0" style="min-width: 30%">
              <app-image-uploader (filesd)="loadfile($event)" [type]="['image/png', 'image/jpg', 'image/jpeg']"
                [maxSize]="2" (imageUploaded)="setParam('photoUuid',$event)"
                [photo]="promotion ? promotion.photo : null "></app-image-uploader>
            </div>
            <div class="col-md">
              <label>Pièces et documents à joindre</label>
              <app-folder-uploader [maxSize]="3" (filesd)="files($event)"
                (filesUploaded)="setParam('folderUuid',$event)" [type]="['image/png', 'image/jpg', 'image/jpeg']"
                [path]="'promotion'" [etat]="edit ? 'edit': 'add'"
                [folder]="edit && promotion ? promotion?.folder : null">
              </app-folder-uploader>
            </div>
          </div>

          <div class="col-md-12 text-center mt-2"
            *ngIf="!edit && (f.type.value === 'TYPE_A' || f.type.value === 'TYPE_C' || f.type.value === 'TYPE_B')">
            <button type="button" awNextStep class="btn btn-primary">
              Suivant <i class="feather icon-arrow-right"></i>
            </button>
          </div>
        </aw-wizard-step>

        <!-- STEP 2 - CONFIGURATION DES MAISONS SIMPLES (TYPE A et TYPE C) -->
        <aw-wizard-step stepTitle="Maisons simples"
          *ngIf="!edit && (f.type.value === 'TYPE_A' || f.type.value === 'TYPE_C')">
          <div class="row">
            <span class="badge badge-primary my-2 f-14 width">
              Configuration des maisons simples
              <span *ngIf="f.type.value === 'TYPE_C'" class="badge badge-secondary ms-2">
                Optionnel pour TYPE C
              </span>
            </span>
          </div>

          <!-- Configuration du radical et décompte -->
          <div class="card mb-3">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-cog me-2"></i>Configuration de la numérotation des lots
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <label for="radicalCode">
                    Radical du code (optionnel)
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Préfixe qui sera ajouté devant chaque numéro de lot. Ex: LOT, VILLA, etc.'"></i>
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="radicalCode"
                    [ngModelOptions]="{standalone: true}" id="radicalCode" placeholder="Ex: LOT, VILLA..."
                    (blur)="validateRadicalCode(radicalCode) || (radicalCode = '')">
                  <small class="text-muted">Laissez vide pour une numérotation simple</small>
                </div>
                <div class="col-md-2">
                  <label for="startNumber">
                    Numéro de départ <span class="asterix">*</span>
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Numéro à partir duquel commencer le décompte'"></i>
                  </label>
                  <input type="number" min="1" class="form-control" [(ngModel)]="startNumber"
                    [ngModelOptions]="{standalone: true}" id="startNumber" placeholder="Ex: 1, 100...">
                </div>
                <div class="col-md-2" *ngIf="!radicalCode || radicalCode.trim() === ''">
                  <label for="defaultIlot">
                    Ilot par défaut <span class="asterix">*</span>
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Numéro d\'ilot utilisé quand aucun radical n\'est défini'"></i>
                  </label>
                  <input type="number" min="1" class="form-control" [(ngModel)]="defaultIlot"
                    [ngModelOptions]="{standalone: true}" id="defaultIlot" placeholder="Ex: 1">
                </div>
                <div class="col-md-3">
                  <label for="numberingMode">
                    Mode de numérotation
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Choisissez comment numéroter les nouveaux lots'"></i>
                  </label>
                  <select class="form-control" [(ngModel)]="numberingMode" [ngModelOptions]="{standalone: true}">
                    <option value="continue">Continuer la série existante</option>
                    <option value="restart">Redémarrer avec le n° de départ</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label>&nbsp;</label>
                  <button type="button" class="btn btn-info form-control" (click)="regenerateAllLotNumbers()"
                    *ngIf="home.length > 0">
                    <i class="fas fa-sync-alt"></i> Appliquer
                  </button>
                </div>
              </div>

              <!-- Aperçu du format -->
              <div class="row mt-2">
                <div class="col-md-12">
                  <div class="alert alert-light">
                    <strong><i class="fas fa-eye me-2"></i>Aperçu du format :</strong>
                    <code>{{getPreviewLotFormat()}}</code>
                    <br>
                    <small class="text-muted">
                      <strong>Ilot :</strong>
                      <span *ngIf="radicalCode && radicalCode.trim() !== ''">
                        Sera égal au numéro du lot
                      </span>
                      <span *ngIf="!radicalCode || radicalCode.trim() === ''">
                        Sera fixé à {{defaultIlot}} pour tous les lots
                      </span>
                      <br>
                      <strong>Mode :</strong>
                      <span *ngIf="numberingMode === 'continue'">
                        <i class="fas fa-arrow-right text-info"></i> Continuer après les lots existants
                      </span>
                      <span *ngIf="numberingMode === 'restart'">
                        <i class="fas fa-redo text-warning"></i> Redémarrer depuis {{startNumber}}
                      </span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Section pour ajouter un nouveau type de maison -->
          <div class="card mb-3">
            <div class="card-header">
              <h6 class="mb-0">Ajouter un type de maison simple</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <label for="newTypeSelection">Type de maison <span class="asterix">*</span></label>
                  <app-entity-finder [class]="'HomeType'" [groups]="['homeType']" [required]="true"
                    (uuid)="setNewTypeUuid($event)">
                  </app-entity-finder>
                </div>
                <div class="col-md-2">
                  <label for="newTypeCount">Nombre <span class="asterix">*</span></label>
                  <input type="number" min="1" class="form-control" [(ngModel)]="newTypeCount"
                    [ngModelOptions]="{standalone: true}" placeholder="Ex: 5">
                </div>
                <div class="col-md-2">
                  <label for="newTypeSuperficie">Superficie (m²) <span class="asterix">*</span></label>
                  <input type="number" min="0" step="0.5" class="form-control" [(ngModel)]="newTypeSuperficie"
                    [ngModelOptions]="{standalone: true}" placeholder="Ex: 150">
                </div>
                <div class="col-md-2">
                  <label for="newTypeMontant">Montant <span class="asterix">*</span></label>
                  <input type="number" min="0" step="1000" class="form-control" [(ngModel)]="newTypeMontant"
                    [ngModelOptions]="{standalone: true}" placeholder="Ex: 50000">
                </div>
                <div class="col-md-2">
                  <label for="newTypeBaseActualisation">Base actualisation <span class="asterix">*</span></label>
                  <input type="number" min="0" step="1000" class="form-control" [(ngModel)]="newTypeBaseActualisation"
                    [ngModelOptions]="{standalone: true}" placeholder="Ex: 45000">
                </div>
                <div class="col-md-1">
                  <label>&nbsp;</label>
                  <button type="button" class="btn btn-success form-control" (click)="addMaisonType()">
                    <i class="fas fa-plus"></i> Ajouter
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Liste des types configurés -->
          <div class="card mb-3" *ngIf="maisonTypes.length > 0">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">Types configurés (Total: {{getTotalMaisons()}} maisons)</h6>
              <button type="button" class="btn btn-primary btn-sm" (click)="generateAllMaisons()">
                <i class="fas fa-magic"></i> Générer toutes les maisons
              </button>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-sm table-striped">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Nombre</th>
                      <th>Superficie (m²)</th>
                      <th>Montant</th>
                      <th>Base actualisation</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let type of maisonTypes; let i = index">
                      <td>{{type.typeLabel}}</td>
                      <td>{{type.count}}</td>
                      <td>{{type.superficie}}</td>
                      <td>{{type.montant}} XOF</td>
                      <td>{{type.baseActualisation}} XOF</td>
                      <td>
                        <span class="badge" [ngClass]="type.generated ? 'badge-success' : 'badge-warning'">
                          {{type.generated ? 'Généré' : 'En attente'}}
                        </span>
                      </td>
                      <td>
                        <button type="button" class="btn btn-sm btn-outline-primary me-1"
                          (click)="generateMaisonsByType(i)">
                          <i class="fas fa-magic"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeMaisonType(i)">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Message informatif pour TYPE_C -->
          <div class="alert alert-info" *ngIf="f.type.value === 'TYPE_C'">
            <i class="fas fa-info-circle me-2"></i>
            <strong>Type C :</strong> Vous pouvez configurer des maisons simples ici, puis des bâtiments à l'étape
            suivante,
            ou les deux selon vos besoins.
          </div>

          <div class="col-sm-12 text-center mt-3">
            <div class="btn-group">
              <button type="button" awPreviousStep class="btn btn-warning">
                <i class="feather icon-arrow-left"></i> Précédent
              </button>
              <button type="button" awNextStep class="btn btn-primary ml-1"
                [disabled]="f.type.value === 'TYPE_A' && !canProceedFromMaisonsSimples()">
                Suivant <i class="feather icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </aw-wizard-step>
        
        <!-- STEP 3 - CONFIGURATION DES BÂTIMENTS (TYPE B et TYPE C) -->
        <aw-wizard-step stepTitle="Bâtiments" *ngIf="!edit && (f.type.value === 'TYPE_B' || f.type.value === 'TYPE_C')">
          <div class="row">
            <span class="badge badge-primary my-2 f-14 width">
              Configuration des bâtiments
              <span *ngIf="f.type.value === 'TYPE_C'" class="badge badge-secondary ms-2">
                Optionnel pour TYPE C
              </span>
            </span>
          </div>

          <!-- Section pour ajouter un bâtiment -->
          <div class="card mb-3">
            <div class="card-header">
              <h6 class="mb-0">Ajouter un bâtiment</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <label for="newBuildingLibelle">Libellé du bâtiment <span class="asterix">*</span></label>
                  <input type="text" class="form-control" [(ngModel)]="newBuildingLibelle"
                    [ngModelOptions]="{standalone: true}" placeholder="Ex: Bâtiment A">
                </div>
                <div class="col-md-3">
                  <label for="newBuildingNiveau">Nombre de niveaux <span class="asterix">*</span></label>
                  <input type="number" min="1" class="form-control" [(ngModel)]="newBuildingNiveau"
                    [ngModelOptions]="{standalone: true}" placeholder="Ex: 3">
                </div>
                <div class="col-md-3">
                  <label>&nbsp;</label>
                  <button type="button" class="btn btn-success form-control" (click)="addBatiment()">
                    <i class="fas fa-plus"></i> Ajouter bâtiment
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Message informatif pour TYPE_C -->
          <div class="alert alert-warning" *ngIf="f.type.value === 'TYPE_C'" class="mb-3">
            <i class="fas fa-info-circle me-2"></i>
            <strong>Type C :</strong> Ces bâtiments s'ajouteront aux maisons simples configurées précédemment.
          </div>

          <!-- Liste des bâtiments -->
          <div class="card mb-3" *ngFor="let batiment of batiments; let i = index">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="fas fa-building me-2"></i>
                {{batiment.libelle}} ({{batiment.niveau}} niveaux)
              </h6>
              <div>
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="toggleBatimentExpansion(i)">
                  <i class="fas" [ngClass]="batiment.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>
                <button type="button" class="btn btn-sm btn-outline-danger ms-1" (click)="removeBatiment(i)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>

            <div class="card-body" *ngIf="batiment.expanded !== false">
              <!-- Configuration par niveau -->
              <div class="accordion" [id]="'accordion-' + i">
                <div class="card mb-2" *ngFor="let niveau of batiment.niveaux; let nIndex = index">
                  <div class="card-header p-2" [id]="'heading-' + i + '-' + nIndex">
                    <h6 class="mb-0">
                      <button class="btn btn-link text-left w-100" type="button"
                        (click)="toggleNiveauExpansion(i, nIndex)">
                        <i class="fas" [ngClass]="niveau.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                        <i class="fas fa-layer-group me-2 ms-2"></i>
                        Niveau {{niveau.numero}}
                        <span class="badge badge-info ms-2" *ngIf="niveau.maisonTypes.length > 0">
                          {{getTotalMaisonsNiveau(niveau)}} maisons
                        </span>
                      </button>
                    </h6>
                  </div>

                  <div *ngIf="niveau.expanded" class="card-body">
                    <!-- Ajouter des types de maisons pour ce niveau -->
                    <div class="row mb-3">
                      <div class="col-md-2">
                        <label>Type de maison</label>
                        <app-entity-finder [class]="'HomeType'" [groups]="['homeType']" [required]="true"
                          (uuid)="setNewMaisonTypeForNiveau($event, i, nIndex)">
                        </app-entity-finder>
                      </div>
                      <div class="col-md-1">
                        <label>Nombre</label>
                        <input type="number" min="1" class="form-control" [(ngModel)]="niveau.newMaisonCount"
                          [ngModelOptions]="{standalone: true}" placeholder="Ex: 2">
                      </div>
                      <div class="col-md-2">
                        <label>Superficie (m²)</label>
                        <input type="number" min="0" step="0.5" class="form-control"
                          [(ngModel)]="niveau.newMaisonSuperficie" [ngModelOptions]="{standalone: true}"
                          placeholder="Ex: 80">
                      </div>
                      <div class="col-md-2">
                        <label>Montant</label>
                        <input type="number" min="0" step="1000" class="form-control"
                          [(ngModel)]="niveau.newMaisonMontant" [ngModelOptions]="{standalone: true}"
                          placeholder="Ex: 25000">
                      </div>
                      <div class="col-md-2">
                        <label>Base actualisation</label>
                        <input type="number" min="0" step="1000" class="form-control"
                          [(ngModel)]="niveau.newMaisonBaseActualisation" [ngModelOptions]="{standalone: true}"
                          placeholder="Ex: 23000">
                      </div>
                      <div class="col-md-3">
                        <label>&nbsp;</label>
                        <button type="button" class="btn btn-primary btn-sm form-control"
                          (click)="addMaisonToNiveau(i, nIndex)">
                          <i class="fas fa-plus"></i> Ajouter type
                        </button>
                      </div>
                    </div>

                    <!-- Liste des types de maisons pour ce niveau -->
                    <div *ngIf="niveau.maisonTypes.length > 0">
                      <h6 class="text-muted mb-2">Types de maisons configurés :</h6>
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>Nombre</th>
                              <th>Superficie</th>
                              <th>Montant</th>
                              <th>Base actualisation</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let maisonType of niveau.maisonTypes; let mIndex = index">
                              <td>{{maisonType.typeLabel}}</td>
                              <td>{{maisonType.count}}</td>
                              <td>{{maisonType.superficie}} m²</td>
                              <td>{{maisonType.montant}} XOF</td>
                              <td>{{maisonType.baseActualisation}} XOF</td>
                              <td>
                                <button type="button" class="btn btn-sm btn-outline-danger"
                                  (click)="removeMaisonFromNiveau(i, nIndex, mIndex)">
                                  <i class="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Bouton pour générer toutes les maisons du bâtiment -->
              <div class="text-center mt-3">
                <button type="button" class="btn btn-success" (click)="generateBatimentMaisons(i)"
                  [disabled]="batiment.generated || !canGenerateBatiment(batiment)">
                  <i class="fas fa-magic"></i>
                  {{batiment.generated ? 'Maisons générées' : 'Générer les maisons'}}
                  <span class="badge badge-light ms-2" *ngIf="!batiment.generated">
                    Total: {{getTotalMaisonsBatiment(batiment)}}
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div class="col-sm-12 text-center mt-3">
            <div class="btn-group">
              <button type="button" awPreviousStep class="btn btn-warning">
                <i class="feather icon-arrow-left"></i> Précédent
              </button>
              <button type="button" awNextStep class="btn btn-primary ml-1" [disabled]="f.type.value === 'TYPE_B' && !canProceedFromBatiments() || 
                                  f.type.value === 'TYPE_C' && !hasContentForTypeC()">
                Suivant <i class="feather icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </aw-wizard-step>

        <!-- STEP 4 - LISTE DES MAISONS GÉNÉRÉES (TYPE A) -->
        <aw-wizard-step stepTitle="Maisons" *ngIf="!edit && f.type.value === 'TYPE_A'">
          <div class="row">
            <span class="badge badge-primary my-2 f-14 width">
              Liste des maisons générées
            </span>
          </div>

          <div formArrayName="homes" *ngIf="home.controls.length > 0">
            <div class="table-responsive">
              <table class="table table-sm table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th>Lot N°</th>
                    <th>Ilot N°</th>
                    <th>Type</th>
                    <th>Superficie (m²)</th>
                    <th>Montant</th>
                    <th>Base actualisation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of home.controls; let i=index" [formGroupName]="i">
                    <td>
                      <input type="text" formControlName="lot" class="form-control form-control-sm"
                        style="background-color: white;">
                    </td>
                    <td>
                      <input type="number" formControlName="ilot" class="form-control form-control-sm" [ngClass]="{
                               'is-invalid': submit && item.get('ilot').errors,
                               'is-valid': submit && item.get('ilot').valid
                             }" placeholder="Ilot N°">
                      <div class="invalid-feedback" *ngIf="submit && item.get('ilot').errors">
                        <div *ngIf="item.get('ilot').errors.required">{{required.novide}}</div>
                      </div>
                    </td>
                    <td>
                      <input type="text" [value]="getTypeLabelSync(item.get('type').value)"
                        class="form-control form-control-sm" readonly style="background-color: #f8f9fa;">
                    </td>
                    <td>
                      <input type="number" formControlName="superficie" class="form-control form-control-sm"
                        style="background-color: white;" step="0.5" min="0">
                    </td>
                    <td>
                      <input type="number" formControlName="montant" class="form-control form-control-sm"
                        style="background-color: white;" step="1000" min="0">
                    </td>
                    <td>
                      <input type="number" formControlName="baseActualisation" class="form-control form-control-sm"
                        style="background-color: white;" step="1000" min="0">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-sm-12 text-center mt-3">
            <div class="btn-group">
              <button type="button" awPreviousStep class="btn btn-warning">
                <i class="feather icon-arrow-left"></i> Précédent
              </button>
              <button type="button" awNextStep class="btn btn-primary ml-1" *ngIf="f.isOffre.value === 'OUI'">
                Suivant <i class="feather icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </aw-wizard-step>

        <!-- STEP 4 - LISTE DES BÂTIMENTS ET MAISONS GÉNÉRÉES (TYPE B) -->
        <aw-wizard-step stepTitle="Bâtiments et Maisons" *ngIf="!edit && f.type.value === 'TYPE_B'">
          <div class="row">
            <span class="badge badge-primary my-2 f-14 width">
              Liste des bâtiments et maisons générées
            </span>
          </div>

          <!-- Affichage hiérarchique par bâtiment -->
          <div *ngFor="let batiment of batiments; let batIndex = index" class="card mb-3">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-building me-2"></i>
                {{batiment.libelle}} - {{batiment.niveau}} niveaux
                <span class="badge badge-success ms-2" *ngIf="batiment.generated">
                  {{batiment.homes.length}} maisons générées
                </span>
              </h6>
            </div>
            <div class="card-body" *ngIf="batiment.generated">

              <!-- Résumé par niveau -->
              <div class="row mb-3">
                <div class="col-md-12">
                  <h6><i class="fas fa-chart-pie me-2"></i>Résumé par niveau :</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered">
                      <thead class="thead-light">
                        <tr>
                          <th><i class="fas fa-layer-group me-1"></i>Niveau</th>
                          <th><i class="fas fa-home me-1"></i>Types de maisons</th>
                          <th><i class="fas fa-calculator me-1"></i>Nombre total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let niveau of batiment.niveaux">
                          <td><strong>Niveau {{niveau.numero}}</strong></td>
                          <td>
                            <span *ngFor="let type of niveau.maisonTypes; let last = last"
                              class="badge badge-info me-1 mb-1">
                              {{type.count}}x {{type.typeLabel}}
                            </span>
                            <span *ngIf="niveau.maisonTypes.length === 0" class="text-muted">Aucun type défini</span>
                          </td>
                          <td>
                            <span class="badge badge-primary">{{getTotalMaisonsNiveau(niveau)}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Liste détaillée des maisons avec possibilité d'édition -->
              <div class="row">
                <div class="col-md-12">
                  <h6><i class="fas fa-list me-2"></i>Maisons générées (éditable) :</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th><i class="fas fa-hashtag me-1"></i>N° Maison</th>
                          <th><i class="fas fa-layer-group me-1"></i>Niveau</th>
                          <th><i class="fas fa-home me-1"></i>Type</th>
                          <th><i class="fas fa-ruler-combined me-1"></i>Superficie (m²)</th>
                          <th><i class="fas fa-euro-sign me-1"></i>Montant</th>
                          <th><i class="fas fa-calculator me-1"></i>Base actualisation</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let home of batiment.homes; let homeIndex = index">
                          <!-- Numéro de maison (éditable) -->
                          <td>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="home.numero"
                              [ngModelOptions]="{standalone: true}"
                              (blur)="updateBatimentHomeNumero(batIndex, homeIndex, $event)"
                              style="background-color: white;">
                          </td>

                          <!-- Niveau (non éditable) -->
                          <td>
                            <span class="badge badge-secondary">N{{home.niveau}}</span>
                          </td>

                          <!-- Type (non éditable) -->
                          <td>
                            <span class="badge badge-info">{{home.typeLabel}}</span>
                          </td>

                          <!-- Superficie (éditable) -->
                          <td>
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="home.superficie"
                              [ngModelOptions]="{standalone: true}"
                              (blur)="updateBatimentHomeSuperficie(batIndex, homeIndex, $event)"
                              style="background-color: white;" step="0.5" min="0">
                          </td>

                          <!-- Montant (éditable) -->
                          <td>
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="home.montant"
                              [ngModelOptions]="{standalone: true}"
                              (blur)="updateBatimentHomeMontant(batIndex, homeIndex, $event)"
                              style="background-color: white;" step="1000" min="0">
                          </td>

                          <!-- Base actualisation (éditable) -->
                          <td>
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="home.baseActualisation"
                              [ngModelOptions]="{standalone: true}"
                              (blur)="updateBatimentHomeBaseActualisation(batIndex, homeIndex, $event)"
                              style="background-color: white;" step="1000" min="0">
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 text-center mt-3">
            <div class="btn-group">
              <button type="button" awPreviousStep class="btn btn-warning">
                <i class="feather icon-arrow-left"></i> Précédent
              </button>
              <button type="button" awNextStep class="btn btn-primary ml-1" *ngIf="f.isOffre.value === 'OUI'">
                Suivant <i class="feather icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </aw-wizard-step>

        <!-- STEP 4 - RÉCAPITULATIF COMPLET (TYPE C) -->
        <aw-wizard-step stepTitle="Récapitulatif" *ngIf="!edit && f.type.value === 'TYPE_C'">
          <div class="row">
            <span class="badge badge-primary my-2 f-14 width">
              Récapitulatif du programme mixte (TYPE C)
            </span>
          </div>

          <!-- Section Maisons Simples -->
          <div class="card mb-3" *ngIf="maisonTypes.length > 0">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-home me-2"></i>
                Maisons simples ({{getTotalMaisons()}} maisons)
              </h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-sm table-striped">
                  <thead class="thead-light">
                    <tr>
                      <th>Lot N°</th>
                      <th>Ilot N°</th>
                      <th>Type</th>
                      <th>Superficie (m²)</th>
                      <th>Montant</th>
                      <th>Base actualisation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of home.controls; let i=index">
                      <td>
                        <input type="text" [value]="item.get('lot').value" (blur)="updateSimpleLot(i, $event)"
                          class="form-control form-control-sm" style="background-color: white;">
                      </td>
                      <td>
                        <input type="number" [value]="item.get('ilot').value" (blur)="updateSimpleIlot(i, $event)"
                          class="form-control form-control-sm" style="background-color: white;">
                      </td>
                      <td>
                        <span class="badge badge-info">{{getTypeLabelSync(item.get('type').value)}}</span>
                      </td>
                      <td>
                        <input type="number" [value]="item.get('superficie').value"
                          (blur)="updateSimpleSuperficie(i, $event)" class="form-control form-control-sm"
                          style="background-color: white;" step="0.5" min="0">
                      </td>
                      <td>
                        <input type="number" [value]="item.get('montant').value" (blur)="updateSimpleMontant(i, $event)"
                          class="form-control form-control-sm" style="background-color: white;" step="1000" min="0">
                      </td>
                      <td>
                        <input type="number" [value]="item.get('baseActualisation').value" (blur)="updateSimpleBaseActualisation(i, $event)"
                          class="form-control form-control-sm" style="background-color: white;" step="1000" min="0">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Section Bâtiments -->
          <div class="card mb-3" *ngFor="let batiment of batiments; let batIndex = index">
            <ng-container *ngIf="batiment.generated">
              <div class="card-header">
                <h6 class="mb-0">
                  <i class="fas fa-building me-2"></i>
                  {{batiment.libelle}} - {{batiment.niveau}} niveaux
                  <span class="badge badge-success ms-2">
                    {{batiment.homes.length}} maisons
                  </span>
                </h6>
              </div>
              <div class="card-body">
                <!-- Résumé par niveau -->
                <div class="row mb-3">
                  <div class="col-md-12">
                    <h6><i class="fas fa-chart-pie me-2"></i>Résumé par niveau :</h6>
                    <div class="table-responsive">
                      <table class="table table-sm table-bordered">
                        <thead class="thead-light">
                          <tr>
                            <th><i class="fas fa-layer-group me-1"></i>Niveau</th>
                            <th><i class="fas fa-home me-1"></i>Types de maisons</th>
                            <th><i class="fas fa-calculator me-1"></i>Nombre total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let niveau of batiment.niveaux">
                            <td><strong>Niveau {{niveau.numero}}</strong></td>
                            <td>
                              <span *ngFor="let type of niveau.maisonTypes; let last = last"
                                class="badge badge-info me-1 mb-1">
                                {{type.count}}x {{type.typeLabel}}
                              </span>
                              <span *ngIf="niveau.maisonTypes.length === 0" class="text-muted">Aucun type défini</span>
                            </td>
                            <td>
                              <span class="badge badge-primary">{{getTotalMaisonsNiveau(niveau)}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Liste détaillée des maisons du bâtiment -->
                <div class="row">
                  <div class="col-md-12">
                    <h6><i class="fas fa-list me-2"></i>Maisons du bâtiment (éditable) :</h6>
                    <div class="table-responsive">
                      <table class="table table-sm table-striped">
                        <thead class="thead-dark">
                          <tr>
                            <th>N° Maison</th>
                            <th>Niveau</th>
                            <th>Type</th>
                            <th>Superficie (m²)</th>
                            <th>Montant</th>
                            <th>Base actualisation</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let home of batiment.homes; let homeIndex = index">
                            <!-- Numéro (éditable) -->
                            <td>
                              <input type="text" class="form-control form-control-sm" [(ngModel)]="home.numero"
                                [ngModelOptions]="{standalone: true}"
                                (blur)="updateBatimentHomeNumero(batIndex, homeIndex, $event)"
                                style="background-color: white;">
                            </td>

                            <!-- Niveau (non éditable) -->
                            <td>
                              <span class="badge badge-secondary">N{{home.niveau}}</span>
                            </td>

                            <!-- Type (non éditable) -->
                            <td>
                              <span class="badge badge-info">{{home.typeLabel}}</span>
                            </td>

                            <!-- Superficie (éditable) -->
                            <td>
                              <input type="number" class="form-control form-control-sm" [(ngModel)]="home.superficie"
                                [ngModelOptions]="{standalone: true}"
                                (blur)="updateBatimentHomeSuperficie(batIndex, homeIndex, $event)"
                                style="background-color: white;" step="0.5" min="0">
                            </td>

                            <!-- Montant (éditable) -->
                            <td>
                              <input type="number" class="form-control form-control-sm" [(ngModel)]="home.montant"
                                [ngModelOptions]="{standalone: true}"
                                (blur)="updateBatimentHomeMontant(batIndex, homeIndex, $event)"
                                style="background-color: white;" step="1000" min="0">
                            </td>

                            <!-- Base actualisation (éditable) -->
                            <td>
                              <input type="number" class="form-control form-control-sm" [(ngModel)]="home.baseActualisation"
                                [ngModelOptions]="{standalone: true}"
                                (blur)="updateBatimentHomeBaseActualisation(batIndex, homeIndex, $event)"
                                style="background-color: white;" step="1000" min="0">
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Statistiques globales -->
          <div class="card bg-light mb-3">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-chart-bar me-2"></i>
                Statistiques globales du programme
              </h6>
            </div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col-md-3">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-home text-primary me-2 fa-2x"></i>
                    <div>
                      <small class="text-muted">Maisons simples</small>
                      <div class="font-weight-bold h4">{{getTotalMaisons()}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-building text-info me-2 fa-2x"></i>
                    <div>
                      <small class="text-muted">Bâtiments</small>
                      <div class="font-weight-bold h4">{{batiments.length}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-layer-group text-warning me-2 fa-2x"></i>
                    <div>
                      <small class="text-muted">Maisons en bâtiments</small>
                      <div class="font-weight-bold h4">{{getBatimentsTotalHomes()}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-calculator text-success me-2 fa-2x"></i>
                    <div>
                      <small class="text-muted">Total général</small>
                      <div class="font-weight-bold h4">{{getTotalGeneral()}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 text-center mt-3">
            <div class="btn-group">
              <button type="button" awPreviousStep class="btn btn-warning">
                <i class="feather icon-arrow-left"></i> Précédent
              </button>
              <button type="button" awNextStep class="btn btn-primary ml-1" *ngIf="f.isOffre.value === 'OUI'">
                Suivant <i class="feather icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </aw-wizard-step>

        <!-- STEP 5 - OFFRE (existant) -->
        <aw-wizard-step stepTitle="Offre" *ngIf="!edit && f.isOffre.value === 'OUI'">
          <div class="row">
            <span class="badge badge-primary my-2 f-14 width"> Informations supplémentaires</span>
          </div>

          <div class="row m-2 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Les informations relatives aux pièces du bien</span>
            <form autocomplete="off" [formGroup]="pieceForm">
              <div class="form-group">
                <div class="row mb-2">
                  <div class="col-md-3">
                    <label for="chambre">Chambres </label>
                    <input type="number" min="0" class="form-control" formControlName="chambre" id="chambre">
                  </div>
                  <div class="col-md-3">
                    <label for="douche">Douches </label>
                    <input type="number" min="0" class="form-control" formControlName="douche" id="douche">
                  </div>
                  <div class="col-md-3">
                    <label for="salon">Salons </label>
                    <input type="number" min="0" class="form-control" formControlName="salon" id="salon">
                  </div>
                  <div class="col-md-3">
                    <label for="garage">Garages </label>
                    <input type="number" min="0" class="form-control" formControlName="garage" id="garage">
                  </div>
                  <div class="col-md-3">
                    <label for="cuisine">Cuisine </label>
                    <input type="number" min="0" class="form-control" formControlName="cuisine" id="cuisine">
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="row m-2 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Les informations relatives aux équipements du
              bien</span>
            <div class="col-md-12">
              <form autocomplete="off" [formGroup]="equipementForm">
                <div class="form-group">
                  <div class="row m-4">
                    <div class="col-md-4">
                      <p>
                        <input class="form-check-input" id="wifi" type="checkbox" formControlName="wifi">
                        <label for="wifi">WiFi </label>
                      </p>
                      <p>
                        <input class="form-check-input" id="piscine" type="checkbox" formControlName="piscine">
                        <label for="piscine">Piscine </label>
                      </p>
                      <p>
                        <input class="form-check-input" id="securite" type="checkbox" formControlName="securite">
                        <label for="securite">Gardien de Sécurité</label>
                      </p>
                    </div>
                    <div class="col-md-4">
                      <p>
                        <input class="form-check-input" id="clim" type="checkbox" formControlName="clim">
                        <label for="clim">Air Conditioner </label>
                      </p>
                      <p>
                        <input class="form-check-input" id="urgence" type="checkbox" formControlName="urgence">
                        <label for="urgence">Issue d'Urgence</label>
                      </p>
                      <p>
                        <input class="form-check-input" id="incendie" type="checkbox" formControlName="incendie">
                        <label for="incendie">Borne d'incendie </label>
                      </p>
                    </div>
                    <div class="col-md-4">
                      <p>
                        <input class="form-check-input" id="parking" type="checkbox" formControlName="parking">
                        <label for="parking">Parking </label>
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="row m-4 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> La galerie du bien</span>
            <div class="col-md-12">
              <app-folder-upload (filesUploaded)="uploadFile($event, 'GALLERY')" [maxSize]="3"
                [type]="['jpg', 'png', 'jpeg']" [etat]="'add'" [folder]="null">
              </app-folder-upload>
            </div>
          </div>

          <div class="row m-2 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Vidéo de présentation</span>
            <div class="col-md-12">
              <form autocomplete="off" [formGroup]="videoForm">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-12">
                      <label for="link">Lien de la vidéo <span class="asterix">*</span></label>
                      <input type="text" class="form-control" formControlName="link" id="link">
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="row m-4 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Plan</span>
            <div class="col-md-12">
              <app-folder-upload-2 (filesUploaded)="uploadFile($event, 'PLAN')" [maxSize]="3"
                [type]="['jpg', 'png', 'jpeg']" [etat]="'add'" [folder]="null">
              </app-folder-upload-2>
            </div>
          </div>

          <div class="col-sm-12 text-center mt-3">
            <div class="btn-group">
              <button type="button" awPreviousStep class="btn btn-warning">
                <i class="feather icon-arrow-left"></i> Précédent
              </button>
            </div>
          </div>
        </aw-wizard-step>
      </aw-wizard>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="modal.close('ferme')" type="button" class="btn btn-secondary text-left" data-dismiss="modal">
      Fermer <i class="feather icon-x-circle"></i>
    </button>
    <button (click)="form.reset()" type="button" class="btn btn-warning">
      Vider <i class="fas fa-broom"></i>
    </button>
    <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
      Enregistrer <i class="feather icon-save"></i>
    </button>
  </div>
</form>